'use strict'

module.exports = name => window[name]
